import { api } from "../../modules/Axios/api";
import { handleError } from "../../telas/jornada/Utils";
import { UserThemeData } from "./dto";

export const getUserThemeData = async (): Promise<UserThemeData | null> => {
    const { data } = await api
        .get("/user-theme/")
        .catch((error) => handleError(error));

    return data;
};

export const getWhiteLabelData = async (companyId: number) => {
    const { data } = await api
        .get("/user-theme/by-company/", {
            params: {
                company_id: companyId,
            },
        })
        .catch((error) => handleError(error));

    return data;
};

export const updateCompanyWhiteLabelData = async (
    companyId: number,
    data: any,
) => {
    await api
        .patch(`/user-theme/by-company/${companyId}/`, data)
        .catch((error) => handleError(error));
};

export const getDomainThemeData = async (
    hostname: string,
): Promise<UserThemeData | null> => {
    const { data } = await api.get("/user-theme/by-hostname/", {
        params: {
            hostname: hostname,
        },
    });

    return data;
};
